// Columns of the HWS trail Analysis export (same names and order as the bulk CSV written by
// server/lambdas/serial_numbers/upload_hws_sns_trail_bulk.py). Shown on the Analysis tab as the
// "Available columns" description.
export const hwsTrailAnalysisColumns = [
  {
    name: "SK",
    description:
      "Unique identifier of the trail line (KSUID: it also encodes the creation time of the line).",
  },
  {
    name: "hws_order_id",
    description: "SAP Hardware Support order the line belongs to.",
  },
  {
    name: "hws_base_order_line",
    description:
      "Base order line (*00) of the HWS order. SAP splits an HWS line into *10 (returned asset) and *20 (replacement), both folded back here.",
  },
  {
    name: "order_line_type",
    description:
      "single_quantity: one line per order line, the IN and the OUT serial numbers are matched on it. multi_quantity: one line per serial number.",
  },
  {
    name: "product_type",
    description:
      "VOICE or DATA, taken from the serial number reference (the first side to arrive). UNDEFINED when the serial number has no product type. Empty on lines created before the attribute existed and not backfilled yet.",
  },
  {
    name: "status",
    description:
      "To do: not swapped yet — waiting for the missing side (IN or OUT serial number) or, when both are present, for the other lines of the same order to be complete (automatic swap rule 6). Done: swapped (replaced_by tells how). Manual Check Required: the automatic swap refused the line, see error_reason. Automatic Swap Deactivated: the business partner does not allow the automatic swap. Error: legacy status of the manual/API swap.",
  },
  {
    name: "error_reason",
    description:
      "Why the automatic swap set the line to Manual Check Required.",
  },
  {
    name: "replaced_by",
    description:
      "Who swapped the line: Automatic Swap, or the user/process of a manual swap. Empty while not swapped.",
  },
  {
    name: "swap_date",
    description: "Date the swap was done. Empty while not swapped.",
  },
  {
    name: "hws_identification_date",
    description:
      "Date the line was created (first IN or OUT serial number received).",
  },
  {
    name: "serial_number_hws_in",
    description:
      "Returned (defective) asset. Empty when ALE has shipped the replacement but the return has not been received yet.",
  },
  {
    name: "part_number_hws_in",
    description: "Part number of the returned asset.",
  },
  {
    name: "order_line_hws_in",
    description: "Order line (*10) on which the returned asset was received.",
  },
  {
    name: "hws_in_arrival_date",
    description: "Date the returned asset was received.",
  },
  {
    name: "business_partner_hws_in",
    description: "Business partner of the returned asset.",
  },
  {
    name: "applicant_id_hws_in",
    description: "Sold-to (applicant) of the returned asset.",
  },
  {
    name: "support_partner_hws_in",
    description: "Support partner of the returned asset.",
  },
  {
    name: "end_customer_hws_in",
    description: "End customer (SFDC account id) of the returned asset.",
  },
  {
    name: "bundle_reference_hws_in",
    description: "Bundle reference of the returned asset (Unknown when none).",
  },
  {
    name: "hws_in_warranty_end_date",
    description: "Warranty end date of the returned asset.",
  },
  {
    name: "hws_in_warranty_service_level",
    description:
      "Warranty service level of the returned asset (e.g. AVR, RTF).",
  },
  {
    name: "hws_in_purchased_contracts",
    description:
      "Purchased contracts of the returned asset at reception time (JSON list: contract reference, type, entitlement dates and status). They are transferred to the replacement by the swap.",
  },
  {
    name: "serial_number_hws_out",
    description:
      "Replacement asset shipped by ALE. Empty when the return has been received but no replacement is recorded.",
  },
  {
    name: "part_number_hws_out",
    description: "Part number of the replacement.",
  },
  {
    name: "order_line_hws_out",
    description: "Order line (*20) on which the replacement was shipped.",
  },
  {
    name: "hws_out_departure_date",
    description: "Date the replacement was shipped.",
  },
  {
    name: "business_partner_hws_out",
    description: "Business partner of the replacement.",
  },
  {
    name: "applicant_id_hws_out",
    description: "Sold-to (applicant) of the replacement.",
  },
  {
    name: "support_partner_hws_out",
    description: "Support partner of the replacement.",
  },
  {
    name: "end_customer_hws_out",
    description: "End customer (SFDC account id) of the replacement.",
  },
  {
    name: "bundle_reference_hws_out",
    description: "Bundle reference of the replacement (Unknown when none).",
  },
  {
    name: "GSI2PK",
    description:
      "Counter bucket of the line: swapped_/unswapped_ followed by active_contract, with_end_customer, with_support_partner or with_no_info (first one that applies to the returned asset).",
  },
];
